import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

const TextWrapper = styled.div`
  max-width: var(--maxContentWidthPages);
  padding: 0 var(--maxContentPadding);
  color: var(--mainNeutral);
  font-size: 1.2rem;
`;

const FirstParagraph = styled.p`
  font-weight: normal;
`;

export default function LandingText() {
  return (
    <Container>
      <TextWrapper>
        <FirstParagraph>
          In Context Research enables valid product and ad tests in popular media contexts like
          Amazon, Instagram and YouTube.
        </FirstParagraph>
        <p>
          In Context Platform is a versatile, entertaining and insight-strong experimental
          environment. It enables a novel, highly scalable ad-effect and campaign optimization
          approach and provides panel-respondents and brands with a datasafe alternative to ad-tests
          with real users and tracking studies.
        </p>
      </TextWrapper>
    </Container>
  );
}
